<template>
  <el-dialog
    :title="editForm.id==null||editForm==''?'登记型号':'编辑型号'"
    :visible="editFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :modal-append-to-body='false'
    :before-close="clearEditForm">
    <!--外部对话框 form-->
    <el-form :model="editForm" ref="editForm" :rules="editFormRules" size="mini" class="edit_form">
      <el-col :span="12">
        <el-form-item label="型号代码" :label-width="formLabelWidth" prop="typeModel">
          <el-input v-model="editForm.typeModel" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="型号名称" :label-width="formLabelWidth" prop="typeName">
          <el-input v-model="editForm.typeName" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="额定功率" :label-width="formLabelWidth" prop="ratedPower">
          <el-input v-model="editForm.ratedPower" autocomplete="off"  maxlength="4" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="输出电压范围(VDC)" :label-width="formLabelWidth" prop="outputVoltageRange">
          <el-input v-model="editForm.outputVoltageRange" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="输出电流范围(A)" :label-width="formLabelWidth" prop="outputCurrentRange">
          <el-input v-model="editForm.outputCurrentRange" autocomplete="off"  maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <!--          <el-col :span="12">-->
      <!--            <el-form-item label="每把枪均充电流范围（A）" :label-width="formLabelWidth" prop="chargingCurrentRangePerGun">-->
      <!--              <el-input v-model="editForm.chargingCurrentRangePerGun" autocomplete="off"></el-input>-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <el-col :span="12">
        <el-form-item label="功率分配方式" :label-width="formLabelWidth" prop="powerDistributionMode">
          <el-select placeholder="请选择" v-model="editForm.powerDistributionMode">
            <el-option v-for="item in powerDistributionModeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="枪线长度(米)" :label-width="formLabelWidth" prop="lineLength">
          <el-input v-model="editForm.lineLength" autocomplete="off" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="充电枪数量" :label-width="formLabelWidth" prop="gunCount">
          <el-input v-model="editForm.gunCount" autocomplete="off"  maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否带广告机" :label-width="formLabelWidth" prop="advertisingMachine">
          <el-select placeholder="请选择" v-model="editForm.advertisingMachine">
            <el-option v-for="item in advertisingMachineData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="模块品牌型号" :label-width="formLabelWidth" prop="moduleBrandModel">
          <el-input v-model="editForm.moduleBrandModel" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="模块功率(kw)" :label-width="formLabelWidth" prop="modularPower">
          <el-input v-model="editForm.modularPower" autocomplete="off" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="模块数量" :label-width="formLabelWidth" prop="modularCount">
          <el-input v-model="editForm.modularCount" autocomplete="off" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="整机重量（KG）" :label-width="formLabelWidth" prop="completeMachineWeight">
          <el-input v-model="editForm.completeMachineWeight" autocomplete="off"maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="软件版本号" :label-width="formLabelWidth" prop="versionNumber">
          <el-input v-model="editForm.versionNumber" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="电流（区间）" :label-width="formLabelWidth" prop="currentRange">
          <el-input v-model="editForm.currentRange" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="电压（区间）" :label-width="formLabelWidth" prop="voltageRange">
          <el-input v-model="editForm.voltageRange" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="功率（区间）" :label-width="formLabelWidth" prop="powerRange">
          <el-input v-model="editForm.powerRange" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input v-model="editForm.remark" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <!--隐藏id-->
      <el-col :span="12">
        <el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
          <el-input v-model="editForm.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <!--footer -->
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" plain @click="clearEditForm">取 消</el-button>
      <el-button size="mini" plain type="primary" @click.native="editSubmit" :loading="editSubmitLoading">提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {isDecimalThanZero,isInteger} from '../../../../common/validator'
  export default {
    name: "add",
    data(){
      return{
        editFormRules: {
          typeModel: [{required: true, message: '桩类型型号', trigger: 'blur'}],
          typeName: [{required: true, message: '桩类型名称', trigger: 'blur'}],
          ratedPower: [{required: true, message: '额定功率', trigger: 'blur'},{validator:isDecimalThanZero,trigger: 'blur'}],
          outputVoltageRange: [{required: true, message: '输出电压范围', trigger: 'blur'}],
          outputCurrentRange: [{required: true, message: '输出电流范围', trigger: 'blur'}],
          // chargingCurrentRangePerGun: [{required: true, message: '每把枪均充电流范围', trigger: 'blur'}],
          // powerDistributionMode: [{required: true, message: '功率分配方式', trigger: 'blur'}],
          lineLength: [{
            required: false,
            type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },
            message: '请输入数字',
          }],
          gunCount: [{required: true, message: '充电枪数量', trigger: 'blur'},{validator:isInteger,trigger: 'blur'}],
          // advertisingMachine: [{required: true, message: '是否带广告机', trigger: 'blur'}],
          // moduleBrandModel: [{required: true, message: '模块品牌型号', trigger: 'blur'}],
          modularPower: [{
            required: false,
            type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },
            message: '请输入数字',
          }],
          modularCount: [{
            required: false,
            type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },
            message: '请输入数字',
          }],
          completeMachineWeight: [{
            required: false,
            type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },
            message: '请输入数字',
          }],
          // versionNumber:[{required: true, message: '软件版本号', trigger: 'blur'}],
          // currentRange: [{required: true, message: '电流', trigger: 'blur'}],
          // voltageRange: [{required: true, message: '电压', trigger: 'blur'}],
          // powerRange: [{required: true, message: '功率', trigger: 'blur'}]

        },
        formLabelWidth: '190px',
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
      powerDistributionModeData:"",
      advertisingMachineData:"",
      editSubmitLoading:false
    },
    methods:{
      clearEditForm(){
        let _this = this
        console.log(this.editForm.id)
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    .el-form-item__content {
      .el-input {
        width: 180px;
      }
    }
  }

  .timeLabOut {
    margin-top: 20px;
    user-select: none;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }

  .timeLabIn {
    user-select: none;
    width: 100%;
    line-height: 40px;
  }

  .timeLabInCol {
    user-select: none;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .topCheck {
    background-color: rgba(64, 158, 255, 0.6);
  }

  .summitCheck {
    background-color: rgba(103, 194, 58, 0.6);
  }

  .flatCheck {
    background-color: rgba(245, 108, 108, 0.6);
  }

  .valleyCheck {
    background-color: rgba(230, 162, 60, 0.6);
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/typeManager/add.vue